import React, { PropTypes } from 'react';
import $ from 'jquery';
import { IconButton } from 'material-ui';
import { ShareButtons, generateShareIcon } from 'react-share';
import R from 'ramda';

import CopyLinkIcon from 'material-ui/svg-icons/editor/insert-link';
import ShareIcon from 'material-ui/svg-icons/social/share';
import CloseIcon from 'material-ui/svg-icons/navigation/close';

const { FacebookShareButton, LinkedinShareButton, TwitterShareButton } = ShareButtons;
const FacebookIcon = generateShareIcon('facebook');
const TwitterIcon = generateShareIcon('twitter');
const LinkedinIcon = generateShareIcon('linkedin');

const SharePost = props => {
  const {
    shareLinksOpen,
    companyName,
    shareableLink,
    postId,
    message,
    openShareLinks,
    trackShareClicks,
  } = props;

  const ShareLinksIcon = shareLinksOpen ? CloseIcon : ShareIcon;
  const shareButtonStyle = { display: 'inline-block', position: 'relative', left: '-10px', cursor: 'pointer', opacity: 0, transition: 'all 250ms cubic-bezier(0.06,.93,.77,1)' };
  const copyLink = (element) => {
    const $temp = $('<input>');
    $('body').append($temp);
    $temp.val($(element).text()).select();
    document.execCommand('copy');
    $temp.remove();
  };

  return (
    <div className={shareLinksOpen ? 'share-icons-outer-div' : ''} style={{ display: 'flex' }}>
      <div className={shareLinksOpen ? 'share-icons' : ''} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
        onClick={openShareLinks}
      >
        <span
          style={Object.assign({ transition: 'transform 455ms', transform: 'rotate(0)', position: 'relative', top: '2px' },
            shareLinksOpen ? { transform: 'rotate(90deg)', top: '0' } : {}
          )}
        >
          <ShareLinksIcon style={{ fill: '#999', height: '16px', width: '16px' }}/>
        </span>
        <span
          style={Object.assign({ display: 'inline-block', opacity: 1, transition: 'all 455ms ease-out', postion: 'relative', top: 0 },
            shareLinksOpen ? { display: 'none', opacity: 0, top: '10px' } : {}
          )}
        >
          &nbsp;Share
        </span>
      </div>
      <div
        style={Object.assign({ display: 'flex', opacity: 0, marginLeft: '10px', transition: 'all 455ms ease-in-out' },
          shareLinksOpen ? { opacity: 1 } : {}
        )}
      >
        <span style={R.merge(shareButtonStyle, shareLinksOpen ? { opacity: 1, left: '5px' } : {})}>
          {/* SERVER SIDE RENDERING IN ORDER FOR FB OG TO WORK */}
          <FacebookShareButton url={shareableLink} quote={`${companyName} via TourConnect: ${message}`} hashtag="#TourConnect" onClick={() => trackShareClicks('facebook')}>
            <FacebookIcon round size={20} />
          </FacebookShareButton>
        </span>
        <span style={R.merge(shareButtonStyle, shareLinksOpen ? { opacity: 1, left: '10px' } : {})}>
          <TwitterShareButton url={shareableLink} title={companyName} via="TourConnect" onClick={() => trackShareClicks('twitter')}>
            <TwitterIcon round size={20}/>
          </TwitterShareButton>
        </span>
        <span style={R.merge(shareButtonStyle, shareLinksOpen ? { opacity: 1, left: '15px' } : {})}>
          <LinkedinShareButton url={shareableLink} title={`${companyName} via TourConnect`} description={message} onClick={() => trackShareClicks('linkedin')}>
            <LinkedinIcon round size={20}/>
          </LinkedinShareButton>
        </span>
        <span
          style={R.merge({ display: 'flex', alignItems: 'center', cursor: 'pointer', position: 'relative', left: '-10px', top: '-2px', opacity: 0, transition: 'all 250ms cubic-bezier(0.06,.93,.77,1)' },
            shareLinksOpen ? { opacity: 1, left: '10px' } : {}
          )}
        >
          <span id={postId} style={{ display: 'none' }}>{shareableLink}</span>
          <IconButton
            tooltip="Copy Link"
            onTouchTap={() => {
              copyLink(`#${postId}`);
              window.alert('Link successfully copied!');
              trackShareClicks('clipboard');
            }}
            style={{
              backgroundColor: 'rgb(0, 188, 212)',
              left: '10px',
              top: '2px',
              display: 'inline-block',
              height: '20px',
              width: '20px',
              padding: 0,
              margin: 0,
              border: '1px solid rgb(0, 188, 212)',
              borderRadius: '50%' }}
          >
            <span style={{ height: '14px', width: '14px' }}>
              <CopyLinkIcon color={'#FFFFFF'} style={{ width: '14px', height: '14px', marginTop: '2px' }}/>
            </span>
          </IconButton>
        </span>
      </div>
    </div>
  );
};

SharePost.propTypes = {
  shareLinksOpen: PropTypes.bool,
  companyName: PropTypes.string,
  shareableLink: PropTypes.string,
  postId: PropTypes.string,
  message: PropTypes.string,
  openShareLinks: PropTypes.func,
  trackShareClicks: PropTypes.func,
};

export default SharePost;



// WEBPACK FOOTER //
// ./src/app/components/newsfeed/actionBar/sharePost.jsx